import React, { useCallback, useState } from "react";

const TrashIcon = ({ transform }: { transform?: string }) => {
  const style = transform ? { transform, transition: "transform 0.3s" } : {};
  return (
    <svg
      id="i-trash"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      width={20}
      height={20}
      style={style}
    >
      <path d="M28 6 L6 6 8 30 24 30 26 6 4 6 M16 12 L16 24 M21 12 L20 24 M11 12 L12 24 M12 6 L13 2 19 2 20 6" />
    </svg>
  );
};

const CheckCircleIcon = ({ active }: { active: boolean }) => {
  const fillColor = active ? "#4CAF50" : "#ccc";
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      fill={fillColor}
    >
      <circle
        cx="50"
        cy="50"
        r="45"
        stroke={fillColor}
        strokeWidth="5"
        fill="none"
      />
      <path
        d="M30 50 L45 65 L70 35"
        stroke={fillColor}
        strokeWidth="5"
        fill="none"
      />
    </svg>
  );
};

const IconButton = ({
  onClick,
  active = false,
  icon,
  animation,
  disabled = false,
}: {
  icon: "trash" | "check-circle";
  onClick: () => void;
  active?: boolean;
  animation?: "rotation";
  disabled?: boolean;
}) => {
  const [transform, setTransform] = useState("rotate(0deg) translate(0, 0)");

  const handleClick = useCallback(() => {
    if (disabled) {
      return;
    }

    onClick();
    setTransform("rotate(360deg)");
    setTimeout(() => setTransform("rotate(0deg) translate(0, 0)"), 300);
  }, [disabled, onClick]);

  const handleMouseEnter = () => {
    setTransform("rotate(-12deg)");
  };

  const handleMouseLeave = () => {
    setTransform("rotate(0deg) translate(0, 0)");
  };

  const IconToDisplay = () => {
    switch (icon) {
      case "trash":
        return <TrashIcon transform={animation && transform} />;
      case "check-circle":
        return <CheckCircleIcon active={active} />;
      default:
        return null;
    }
  };

  return (
    <button
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{ background: "none", border: "none", cursor: "pointer" }}
      disabled={disabled}
    >
      <IconToDisplay />
    </button>
  );
};

export default IconButton;
